import { getMfExposedModule } from '@im/ui-lib/mf-utils';
import { useBuildVars } from 'mf_core/config';
import { useEffect, useState } from 'react';

export const useChatbot = () => {
  const [chatbotModule, setChatbotModule] = useState<JSX.Element | null>(null);
  const { buildEnvironment } = useBuildVars();
  const supportChannel = new BroadcastChannel('chat_bot_data');

  supportChannel.onmessage = (event) => {
    console.warn('Received message in cep_app:', event.data);
    if (event.data?.action === 'navigate_to_support') {
      localStorage.setItem('SUPPORT_DESCRIPTION', event.data?.description);
      localStorage.setItem('SUPPORT_KB_STATUS', event.data?.kb_status);
    }
  };

  const conditionsMet =
    buildEnvironment === 'development' ||
    //buildEnvironment === 'staging' ||
    //buildEnvironment === 'stagingx' ||
    //buildEnvironment === 'staging2' ||
    buildEnvironment === 'productionbeta' ||
    buildEnvironment === 'productionbetax';

  useEffect(() => {
    if (conditionsMet) {
      (async () => {
        const ChatbotComponents = await getMfExposedModule(
          'unifiedchat_ai_x4c_mf',
          'components'
        );

        setChatbotModule(ChatbotComponents.Chatbot);
      })();
    }
  }, [conditionsMet]);

  return { chatbotModule, conditionsMet };
};
